import { t as A } from "./toTitleCase-DdbgdWdW.js";
const i = (t, e = {}) => {
  const { conjunction: n = "and", oxfordComma: o = !0 } = e;
  if (t.length === 0) return "";
  if (t.length === 1) return t[0];
  if (t.length === 2) return `${t[0]} ${n} ${t[1]}`;
  const c = t.slice(0, -1), a = t[t.length - 1];
  return o ? `${c.join(", ")}, ${n} ${a}` : `${c.join(", ")} ${n} ${a}`;
}, s = (t) => t.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (e, n, o) => o ? o.toUpperCase() : n.toLowerCase()
), h = (t) => {
  const e = s(t);
  return e.charAt(0).toUpperCase() + e.slice(1);
}, u = (t, e = "camel") => {
  if (!t) return "";
  const n = e === "snake" ? "_" : e === "kebab" ? "-" : ["title", "sentence"].includes(e) ? " " : "", o = ["camel", "pascal"].includes(e) ? (r) => r.slice(0, 1).toUpperCase() + r.slice(1).toLowerCase() : ["snake", "kebab"].includes(e) ? (r) => r.toLowerCase() : e === "title" ? (r) => r.slice(0, 1).toUpperCase() + r.slice(1).toLowerCase() : (r) => r, c = e === "camel" ? (r) => r.slice(0, 1).toLowerCase() + r.slice(1) : e === "sentence" ? (r) => {
    const l = r.split(" ");
    return l.length === 0 ? r : l[0].slice(0, 1).toUpperCase() + l[0].slice(1).toLowerCase() + (l.length > 1 ? " " + l.slice(1).join(" ").toLowerCase() : "");
  } : (r) => r, a = t.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);
  return c((a == null ? void 0 : a.map(o).join(n)) ?? "");
}, f = function(t, e = 0) {
  let n = 3735928559 ^ e, o = 1103547991 ^ e;
  for (let c = 0, a; c < t.length; c++)
    a = t.charCodeAt(c), n = Math.imul(n ^ a, 2654435761), o = Math.imul(o ^ a, 1597334677);
  return n = Math.imul(n ^ n >>> 16, 2246822507), n ^= Math.imul(o ^ o >>> 13, 3266489909), o = Math.imul(o ^ o >>> 16, 2246822507), o ^= Math.imul(n ^ n >>> 13, 3266489909), 4294967296 * (2097151 & o) + (n >>> 0);
}, p = (t) => {
  if (!t) return "";
  const e = t.split(" ");
  let n = "";
  for (let o = 0; o < e.length && o < 2; o++)
    n += e[o].charAt(0).toUpperCase();
  return n;
};
function C(t) {
  let e = 0;
  for (let n = 0; n < t.length; n++) {
    const o = t.charCodeAt(n);
    e = (e << 5) - e + o, e |= 0;
  }
  return e;
}
export {
  p as convertToInitials,
  i as formatList,
  s as toCamelCase,
  u as toConvertedCase,
  f as toEfficientHash,
  h as toPascalCase,
  C as toSimpleHash,
  A as toTitleCase
};
